import { Provider } from "react-redux";

// Import custom components
import store from "./store";
import Routers from "./router";
import { ToastContainer } from "react-toastify";

import "./App.css";
import { Loader } from "./components/loader";

function App() {
  return (
    <Provider store={store} style={{ fontFamily: "verdana" }}>
      <Routers></Routers>
      <ToastContainer />
      <Loader />
    </Provider>
  );
}

export default App;
